import _ from 'underscore';

export const mockEdm = {
  root: {
    identifyEntitySet: () => ({
      navigation: {
        source: {
          $call: () => ({
            toJSON: _.noop,
          }),
        },
        parameters: {},
      },
    }),
  },
  currentCustomer: {
    key: 'customer_id',
    parent: 'root',
    collection: 'Customers',
    Accounts: {
      'Default.HierarchicalPerformanceTimeSeries': {
        $call: () => ({
          toJSON: _.identity,
        }),
      },
      'Default.PerformanceTimeSeries': {
        $call: () => ({
          toJSON: _.identity,
        }),
      },
      $withKey: (id) => ({
        key: id,
        'Default.PerformanceTimeSeries': {
          $call: () => ({
            toJSON: _.identity,
          }),
        },
        Campaigns: {
          'Default.PerformanceTimeSeries': {
            $call: () => ({
              toJSON: _.identity,
            }),
          },
          $withKey: (nid) => ({
            key: nid,
            'Default.PerformanceTimeSeries': {
              $call: () => ({
                toJSON: _.identity,
              }),
            },
          }),
        },
      }),
    },
  },
  currentAccount: {
    key: 'account_id',
    parent: 'currentCustomer',
    collection: 'Accounts',
    Campaigns: {
      'Default.PerformanceTimeSeries': {
        $call: () => ({
          toJSON: _.identity,
        }),
      },
      $withKey: (id) => ({
        key: id,
        'Default.PerformanceTimeSeries': {
          $call: () => ({
            toJSON: _.identity,
          }),
        },
        AdGroups: {
          'Default.PerformanceTimeSeries': {
            $call: () => ({
              toJSON: _.identity,
            }),
          },
          $withKey: (nid) => ({
            key: nid,
            'Default.PerformanceTimeSeries': {
              $call: () => ({
                toJSON: _.identity,
              }),
            },
            Ads: {
              'Default.PerformanceTimeSeries': {
                $call: () => ({
                  toJSON: _.identity,
                }),
              },
              $withKey: (aid) => ({
                key: aid,
                'Default.PerformanceTimeSeries': {
                  $call: () => ({
                    toJSON: _.identity,
                  }),
                },
              }),
            },
            Keywords: {
              'Default.PerformanceTimeSeries': {
                $call: () => ({
                  toJSON: _.identity,
                }),
              },
              $withKey: (kid) => ({
                key: kid,
                'Default.PerformanceTimeSeries': {
                  $call: () => ({
                    toJSON: _.identity,
                  }),
                },
              }),
            },
          }),
        },
      }),
    },
  },
};
